<template>
	<div :id="baseId" class="product-highlights-panel d-flex flex-column">
		<div class="product-highlights-panel-carousel d-flex flex-column">
			<div class="slide_header">
				<h1>Not just another link·in·bio<span>🚀</span><span style="display: none">.</span></h1>
				<h2>Stan has everything you need to run your business. All-in-one place.</h2>
			</div>
			<div class="card">
				<img id="slide" src="/images/home/v6/features.png" alt="slide" class="active" loading="lazy" />
			</div>
		</div>
	</div>
</template>
<script>
	import { computed, defineComponent, getCurrentInstance, ref } from 'vue'
	import { Swiper, SwiperSlide } from 'swiper/vue'
	import { Zoom, Navigation } from 'swiper'
	//import 'swiper/css/navigation'
	//import 'swiper/css'
	import { client } from '@/plugins/platform'
	const productHighlights = [
		{
			id: 'calendar',
			order: 0,
			mobileOrder: 0,
			image: '/images/home/v6/features.svg',
			icon: '/images/home/v6/icons/highlights_calendars.svg',
			title: 'Calendar',
			description: 'Book your calendar meetings, right here in Stan!',
		},
		{
			id: 'courses',
			order: 1,
			mobileOrder: 1,
			image: '/images/home/v6/features-1.svg',
			icon: '/images/home/v6/icons/highlights_courses.svg',
			title: 'Courses',
			description: 'Book your calendar meetings, right here in Stan!',
		},
		{
			id: 'analytics',
			order: 2,
			mobileOrder: 2,
			image: '/images/home/v6/features-2.svg',
			icon: '/images/home/v6/icons/highlights_analytics.svg',
			title: 'Analytics',
			description: 'Book your calendar meetings, right here in Stan!',
		},
		{
			id: 'webinars',
			order: 3,
			mobileOrder: 3,
			image: '/images/home/v6/features-3.svg',
			icon: '/images/home/v6/icons/highlights_webinars.svg',
			title: 'Webinars',
			description: 'Book your calendar meetings, right here in Stan!',
		},
		{
			id: 'downloads',
			order: 4,
			mobileOrder: 4,
			image: '/images/home/v6/features-4.svg',
			icon: '/images/home/v6/icons/highlights_downloads.svg',
			title: 'Downloads',
			description: 'Book your calendar meetings, right here in Stan!',
		},
	]
	export default defineComponent({
		name: 'LandingV6ProductHighlights',
		components: {},
		props: {
			id: {
				type: [String, Number],
			},
			activeComponent: { type: Boolean },
		},
		setup(props) {
			const initialSlide = ref(1)
			const highlightsSwiper = ref(null)
			const isMobile = computed(() => {
				const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
				return client.is.mobile === true || width < 767
			})
			const productHighlightsCarouselRef = ref(null)
			const slidesList = computed(() =>
				productHighlights
					.map(s => ({ ...s }))
					.sort((a, b) => {
						return isMobile.value
							? a.mobileOrder > b.mobileOrder
								? 1
								: b.mobileOrder > a.mobileOrder
								? -1
								: 0
							: a.order > b.order
							? 1
							: b.order > a.order
							? -1
							: 0
					})
			)
			const highlightsTitles = computed(() =>
				slidesList.value.map(s => ({
					id: s.id,
					title: s.title,
					icon: s.icon,
				}))
			)
			const slidesListIndexs = computed(() => {
				const idx = {}
				const ids = {}
				for (let i = 0; i < slidesList.value.length; i += 1) {
					idx[slidesList.value[i].id] = i
					ids[i] = slidesList.value[i].id
				}
				return { idx, ids }
			})
			const activeIndex = computed(() => {
				return highlightsSwiper.value?.activeIndex in slidesListIndexs.value.ids
					? slidesListIndexs.value.ids[highlightsSwiper.value?.activeIndex]
					: ''
			})
			const selectPage = id => {
				const slide = id in slidesListIndexs.value.idx ? slidesListIndexs.value.idx[id] : initialSlide.value
				highlightsSwiper.value.slideToLoop(slide, 500)
			}
			const onSwiper = swiper => {
				highlightsSwiper.value = swiper
			}
			return {
				baseId: `${props.id}`,
				addonId: `${props.id}-add-on`,
				initialSlide,
				onSwiper,
				highlightsSwiper,
				productHighlightsCarouselRef,
				activeIndex,
				highlightsTitles,
				slidesList,
				selectPage,
				modules: [Navigation, Zoom],
			}
		},
	})
</script>
<style lang="scss">
	@import '@/assets/styles/helpers-v6.scss';
	::-webkit-scrollbar {
		height: 0;
	}

	.product-highlights-panel {
		background: white;
	}
	.slide_header {
		image-rendering: -webkit-optimize-contrast;
		text-align: center;
		margin-bottom: 20px;
		margin-top: 400px;
		max-width: 90vw;
		padding-top: 40px;
		margin: auto;
		h1 {
			font-size: 36px;
			font-weight: 900;
			margin-bottom: 30px;
		}
		h2 {
			font-size: 18px;
			font-weight: 400;
		}
	}
	.product-highlights-panel {
		font-family: Plus Jakarta Sans, sans-serif;
		min-height: 100vh;
		padding-top: 40px;
		padding-bottom: 200px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	#bar {
		background: #dde3f5;
		width: 700px;
		height: 5px;
		border-radius: 50px;
		margin: auto;
		position: relative;
		#progress {
			height: 5px;
			width: 10px;
			background: #00106d;
			position: absolute;
			top: 0;
			left: 0;
			border-radius: 50px;
		}
		#bars {
			width: 700px;
			height: 5px;
			top: 0;
			left: 0;
			position: absolute;
			display: flex;
			justify-content: space-between;
			.bar {
				width: 15px;
				height: 5px;
				background: white;
			}
		}
	}
	#gap {
		width: 100px;
		height: 40px;
		color: white;
	}
	.card {
		flex-shrink: 0;
		margin: auto;
		display: flex;
		flex-direction: row;
		align-items: center;
		border: none;
		margin-top: 20px;
		margin-bottom: -140px;
		.expo {
			text-align: left;
			display: none;
			h1 {
				font-size: 54px;
				font-weight: 800;
			}
			p {
				font-family: Inter, sans-serif;
				letter-spacing: -0.5px;
				font-size: 20px;
				margin-top: 20px;
			}
		}
		img {
			width: 1000px !important;
			border: none;
		}
	}
	@media screen and (max-width: 800px) {
		.slide_header {
			padding: 0;
		}
		.carousel {
			height: 100vw !important;
			width: 100vw !important;
			padding: 0 !important;
			margin: 0 !important;
			transform: none !important;
			.card {
				width: 90vw !important;
				img {
					width: 90vw !important;
				}
			}
		}
		#gap {
			display: none;
		}
		.card {
			img {
				margin-top: 100px !important;
				width: 90vw !important;
			}
		}
	}
</style>
